export const GET_POLICY_DETAILS = "GET_POLICY_DETAILS";
export const SAVE_PAYMENT = 'SAVE_PAYMENT';
export const Payload_entry = 'PAYLOAD_ENTRY';
export const SET_UPI_ASBA_FLAG = 'SET_UPI_ASBA_FLAG';
export const GET_POLICY_INVOKE = 'GET_POLICY_INVOKE';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_TOKEN_MIS = 'SET_TOKEN_MIS';
export const SET_PAYMENT_MODE = 'SET_PAYMENT_MODE'
export const SET_SUCCESSFULL_PAYMENT='SET_SUCCESSFULL_PAYMENT'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SAVE_BELSTAR_PAYMENT = 'SAVE_BELSTAR_PAYMENT'
export const SAVE_BELSTAR_AVAILABILITY = 'SAVE_BELSTAR_AVAILABILITY'
export const SET_UNIQUE_IDENTIFIER = 'SET_UNIQUE_IDENTIFIER'
export const SET_LOAN_NUMBER = 'SET_LOAN_NUMBER'
export const SET_SELECTED_PAYMENT_TAB='SET_SELECTED_PAYMENT_TAB'

